import { useEffect, useState } from "react";
import DropdownMenu from "../../../../components/menu/DropdownMenu";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import Job from "../../../crm/jobs/models/Job";
import { useHub } from "../../../../core/Global";
import { API_ROUTES } from "../../../../core/Constants";


interface IProps {
    job?: Job
    jobIds?: string[]
    onAllSettled?: () => void
    onTechSettled?: () => void
    onSourceSettled?: () => void
    onUnsettled?: () => void
}
export default function JobSettleMenu(props: IProps) {

    const hub = useHub()
    const [working, workingSet] = useState<boolean>(false)
    const [techSetteled, techSetteledSet] = useState<boolean>(false)
    const [sourceSetteled, sourceSetteledSet] = useState<boolean>(false)

    const [ids, idsSet] = useState<string[]>([])

    useEffect(() => {
        window.KTMenuCreate()
    }, [working, techSetteled, sourceSetteled])

    useEffect(() => {
        techSetteledSet(props.job?.techSetteled ?? false)
        sourceSetteledSet(props.job?.sourceSetteled ?? false)
    }, [props.job?.techSetteled, props.job?.sourceSetteled])

    useEffect(() => {
        if (props.jobIds) idsSet(props.jobIds)
        else if (props.job?.id) idsSet([props.job.id])
    }, [props.job, props.jobIds])

    return (
        <div>
            {
                working ?
                    <span className="badge text-start badge-secondary">
                        <FlexRow>
                            <div className="me-2">
                                <Icon icon="spinner-third" spin className="p-0 m-0" />
                            </div>
                            <div className="me-3">
                                Please wait...
                            </div>
                        </FlexRow>
                    </span>
                    :
                    <>

                        {
                            props.jobIds ?
                                <span className={`badge text-start cursor-pointer badge-secondary`}
                                    data-kt-menu-trigger="click"
                                    data-kt-menu-placement="bottom-start">
                                    <FlexRow>
                                        <div className="me-2">
                                            <Icon icon="circle-exclamation" className="p-0 m-0" />
                                        </div>
                                        <div className="me-3">
                                            Settle Actions ({props.jobIds.length})
                                        </div>
                                        <div>
                                            <Icon icon="chevron-down" size={10} />
                                        </div>
                                    </FlexRow>
                                </span>
                                : (techSetteled && sourceSetteled) ?
                                    <span className={`badge text-start cursor-pointer badge-success`}
                                        data-kt-menu-trigger="click"
                                        data-kt-menu-placement="bottom-start">
                                        <FlexRow>
                                            <div className="me-2">
                                                <Icon icon="check" className="p-0 m-0" />
                                            </div>
                                            <div className="me-3">
                                                All Settled
                                            </div>
                                            <div>
                                                <Icon icon="chevron-down" className="text-white" size={10} />
                                            </div>
                                        </FlexRow>
                                    </span>
                                    : techSetteled ?
                                        <span className={`badge text-start cursor-pointer badge-primary`}
                                            data-kt-menu-trigger="click"
                                            data-kt-menu-placement="bottom-start">
                                            <FlexRow>
                                                <div className="me-2">
                                                    <Icon icon="user-helmet-safety" className="p-0 m-0" />
                                                </div>
                                                <div className="me-3">
                                                    Tech Settled
                                                </div>
                                                <div>
                                                    <Icon icon="chevron-down" className="text-white" size={10} />
                                                </div>
                                            </FlexRow>
                                        </span>
                                        : sourceSetteled ?
                                            <span className={`badge text-start cursor-pointer badge-info`}
                                                data-kt-menu-trigger="click"
                                                data-kt-menu-placement="bottom-start">
                                                <FlexRow>
                                                    <div className="me-2">
                                                        <Icon icon="bullhorn" className="p-0 m-0" />
                                                    </div>
                                                    <div className="me-3">
                                                        Source Settled
                                                    </div>
                                                    <div>
                                                        <Icon icon="chevron-down" className="text-white" size={10} />
                                                    </div>
                                                </FlexRow>
                                            </span>
                                            :
                                            <span className={`badge text-start cursor-pointer badge-warning`}
                                                onClick={e => {
                                                    window.KTMenuCreate();
                                                }}
                                                data-kt-menu-trigger="click"
                                                data-kt-menu-placement="bottom-start">
                                                <FlexRow>
                                                    <div className="me-2">
                                                        <Icon icon="circle-exclamation" className="p-0 m-0" />
                                                    </div>
                                                    <div className="me-3">
                                                        Unsettle
                                                    </div>
                                                    <div>
                                                        <Icon icon="chevron-down" className="text-white" size={10} />
                                                    </div>
                                                </FlexRow>
                                            </span>

                        }


                        <DropdownMenu width={200}
                            source={[
                                {
                                    title: "All Settled",
                                    icon: "circle",
                                    iconType: "solid",
                                    iconColor: "#17C653",
                                    action() {
                                        workingSet(true)
                                        setTimeout(() => {
                                            hub.Post(API_ROUTES.Jobs + "settleall", ids,
                                                res => {
                                                    if (res.success) {

                                                        if (props.job) {
                                                            techSetteledSet(true)
                                                            sourceSetteledSet(true)
                                                            workingSet(false)
                                                        }

                                                        if (props.onAllSettled) props.onAllSettled()

                                                    }
                                                })
                                        }, 200);

                                    },
                                },
                                {
                                    title: "Tech Settled",
                                    icon: "circle",
                                    iconType: "solid",
                                    iconColor: "#1B84FF",
                                    action() {
                                        workingSet(true)
                                        setTimeout(() => {
                                            hub.Post(API_ROUTES.Jobs + "settletech", ids,
                                                res => {
                                                    if (res.success) {

                                                        if (props.job) {
                                                            techSetteledSet(true)
                                                            sourceSetteledSet(false)
                                                            workingSet(false)
                                                        }

                                                        if (props.onTechSettled) props.onTechSettled()

                                                    }
                                                })
                                        }, 200);
                                    }
                                },
                                {
                                    title: "Source Settled",
                                    icon: "circle",
                                    iconType: "solid",
                                    iconColor: "#7239EA",
                                    action() {
                                        workingSet(true)
                                        setTimeout(() => {
                                            hub.Post(API_ROUTES.Jobs + "settlesource", ids,
                                                res => {
                                                    if (res.success) {

                                                        if (props.job) {
                                                            techSetteledSet(false)
                                                            sourceSetteledSet(true)
                                                            workingSet(false)
                                                        }

                                                        if (props.onSourceSettled) props.onSourceSettled()
                                                    }
                                                })
                                        }, 200);
                                    }
                                },
                                {
                                    title: "Unsettle",
                                    icon: "circle",
                                    iconType: "solid",
                                    iconColor: "#F6C000",
                                    action() {
                                        workingSet(true)
                                        setTimeout(() => {
                                            hub.Post(API_ROUTES.Jobs + "unsettle", ids,
                                                res => {
                                                    if (res.success) {

                                                        if (props.job) {
                                                            techSetteledSet(false)
                                                            sourceSetteledSet(false)
                                                            workingSet(false)
                                                        }

                                                        if (props.onUnsettled) props.onUnsettled()

                                                    }
                                                })
                                        }, 200);
                                    }
                                }
                            ]} />

                    </>
            }
        </div>
    )
}